import { Guid, Nillable } from '@web/utils';
import { BrandSocialMedia } from '../../shared/models/brand-social-media';

export class PublicBrandDetails {
  public constructor(
    public readonly id: Guid,
    public readonly name: string,
    public readonly description: string,
    public readonly homeUrl: Nillable<string>,
    public readonly illustrationAlt: string,
    public readonly illustrationSrc: string,
    public readonly socials: BrandSocialMedia[] = [],
  ) {}
}
